// extracted by mini-css-extract-plugin
module.exports = {"StyleTable":"styles_StyleTable__3Up8c"};